import { z } from 'zod';

export const RevokeMarketingConsentBodySchema = z.object({
  reason: z.string().trim().optional(),
});

export type RevokeMarketingConsentBody = z.infer<typeof RevokeMarketingConsentBodySchema>;
